export default __webpack_public_path__ + "static/media/dogecoin.ef39f904.svg";